import React from 'react'

import type {Element} from 'react'

import {hx} from './index.css'

type HProps = {
  level: number,
  children: Element<any>,
  title?: string
}

export function H(props: HProps) {
  switch (props.level) {
    case 4:
      return (
        <h4 className={hx} title={props.title}>
          {props.children}
        </h4>
      )
    case 3:
    default:
      return (
        <h3 className={hx} title={props.title}>
          {props.children}
        </h3>
      )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/H/index.js